import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { CARD_TEXTS, PUBLISHED, API_URL } from '../../utils/constants';
import axios from "axios";
import { useDispatch } from 'react-redux';
import commonActions from "../../redux/common/actions";

export default function EditModal(props) {
    const { showEditModal, setShowEditModal, courseData } = props;
    
    const dispatch = useDispatch();

    const cardTexts = CARD_TEXTS.filter( (cardText) => {
        return cardText.cardId == courseData?.cardId;
    });

    const { register, handleSubmit, reset, watch } = useForm();
    const publishedValue = watch("published");

    const [formData, setFormData] = useState(courseData);

    useEffect(() => {
        if (courseData) {
            courseData.status = courseData.linkText ? courseData.linkText : courseData.alternativeText
            courseData.published = courseData.published ? "true" : "false";
            reset(courseData);
        }
    }, [courseData])

    const handleClose = () => setShowEditModal(false);

    const onSubmit = async (data) => {

        if ( 
            courseData.published == "true"
            && data.published == "false" && data.published == "false"
            && !window.confirm("Do you want to unpublish the course? The course tile will no longer be visible to candidates.") 
        ) {
            return;
        }

        try {
            const response = await axios.put(`${API_URL}/educationCourses/${courseData.id}`, data);
    
            // Optionally close modal or show success message
            setShowEditModal(false);
            dispatch({ 
                type: commonActions.SET_ALERT, 
                payload: {
                    show: true, 
                    status: 'success',  
                    message: "Course updated successfully."
                } 
            });

            window.location.reload();

        } catch (error) {
            console.error("Error updating course:", error);
            // Optionally show an error message to the user
        }
    };

    return (
        <>
            <Modal show={showEditModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Course</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group mb-3">
                            <label>Course Name:</label>
                            <input {...register("courseName")} className="form-control" disabled/>
                        </div>
                        
                        <div className="form-group mb-3">
                            <label>Category:</label>
                            <input {...register("categoryName")} className="form-control" disabled/>
                        </div>
                        
                        <div className="form-group mb-3">
                            <label>Level:</label>
                            <input {...register("levelName")} className="form-control" disabled/>
                        </div>
                        
                        <div className="form-group mb-3">
                            <label>Published:</label>
                            <select {...register("published")} className="form-control">
                                {PUBLISHED.map(published => (
                                    <option key={published.value} value={published.value}>
                                        {published.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {publishedValue == "true" && (
                            <div className="form-group mb-3">
                                <label>Status:</label>
                                <select {...register("status")} className="form-control">
                                    {/* <option value="">-- Select Status --</option> */}
                                    {cardTexts.map((cardText, index) => (
                                        <option key={`cardText-${index}`} value={cardText.text}>
                                            {cardText.text}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {publishedValue == "true" && (
                            <div className="form-group mb-3">
                                <label>URL:</label>
                                <input {...register("url")} className="form-control" />
                            </div>
                        )}
                        
                        <button type="submit" className="btn btn-primary">Update</button>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}